// extracted by mini-css-extract-plugin
module.exports = {"modalTriggerLabel":"CompanyRateCodeModalTrigger_modalTriggerLabel__nKv6H"};